export const SENTIMENT_TARGETS = [
  { value: 'pessoa', label: 'Pessoa' },
  { value: 'mandato', label: 'Mandato' },
  { value: 'pauta', label: 'Pauta' },
  { value: 'familia', label: 'Família' },
  { value: 'partido_grupo', label: 'Partido/Grupo' },
  { value: 'comportamento', label: 'Comportamento' },
];

export const targetLabel = v =>
  SENTIMENT_TARGETS.find(t => t.value === v)?.label || v || '';
